const contact_info = [
  { name: "Hardeep Singh", field: "713.459.4812", type: "tel" },
  { name: "Sukhpreet Kaur", field: "713.291.5749", type: "tel" },
  { name: "Parminder Singh", field: "713.385.3914", type: "tel" },
];

const EMAIL = "houstonsikhyouthcamp@gmail.com";

export default function ContactSection() {
  return (
    <section className="hsyc-section hsyc-contact" id="contact-section">
      <div className="hsyc-wrap">
        <h2>Questions? Call or email us</h2>
        <ul className="hsyc-contact__list">
          {contact_info.map((c) => (
            <li key={c.name}>
              <a href={`${c.type}:${c.field.replaceAll(".", "")}`}>
                {c.field}
              </a>
              <span>{c.name}</span>
            </li>
          ))}
          <li className="is-email">
            <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
            <span>Camp email</span>
          </li>
        </ul>
      </div>
    </section>
  );
}
